var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"template-connected"},[_c('div',{staticClass:"no-padding",attrs:{"id":"container"}},[_c('div',{staticClass:"notfound"},[_c('div',{staticClass:"page-content"},[_c('div',{staticClass:"page-single-content"},[_c('b-img',{staticClass:"img-login",attrs:{"src":require("../img/404.png"),"alt":"Page non trouver"}})],1)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }